/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_Middle_EastInputs */

const bn_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মধ্যপ্রাচ্য`)
};

const de_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naher Osten`)
};

const el_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μέση Ανατολή`)
};

const en_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middle East`)
};

const es_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oriente Medio`)
};

const fr_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyen-Orient`)
};

const hi_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्य पूर्व`)
};

const hu_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közel-Kelet`)
};

const id_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timur Tengah`)
};

const it_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio Oriente`)
};

const ja_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中東`)
};

const ko_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중동`)
};

const nl_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Midden-Oosten`)
};

const pl_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Środkowy Wschód`)
};

const pt_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio Oriente`)
};

const ru_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Средний Восток`)
};

const sv_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellanöstern`)
};

const tr_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orta Doğu`)
};

const uk_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Близький Схід`)
};

const vi_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung Đông`)
};

const zh_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中东`)
};

const zh_hant_region_middle_east = /** @type {(inputs: Region_Middle_EastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中東`)
};

/**
* | output |
* | --- |
* | "Middle East" |
*
* @param {Region_Middle_EastInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_middle_east = /** @type {((inputs?: Region_Middle_EastInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_Middle_EastInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_middle_east(inputs)
	if (locale === "de") return de_region_middle_east(inputs)
	if (locale === "el") return el_region_middle_east(inputs)
	if (locale === "en") return en_region_middle_east(inputs)
	if (locale === "es") return es_region_middle_east(inputs)
	if (locale === "fr") return fr_region_middle_east(inputs)
	if (locale === "hi") return hi_region_middle_east(inputs)
	if (locale === "hu") return hu_region_middle_east(inputs)
	if (locale === "id") return id_region_middle_east(inputs)
	if (locale === "it") return it_region_middle_east(inputs)
	if (locale === "ja") return ja_region_middle_east(inputs)
	if (locale === "ko") return ko_region_middle_east(inputs)
	if (locale === "nl") return nl_region_middle_east(inputs)
	if (locale === "pl") return pl_region_middle_east(inputs)
	if (locale === "pt") return pt_region_middle_east(inputs)
	if (locale === "ru") return ru_region_middle_east(inputs)
	if (locale === "sv") return sv_region_middle_east(inputs)
	if (locale === "tr") return tr_region_middle_east(inputs)
	if (locale === "uk") return uk_region_middle_east(inputs)
	if (locale === "vi") return vi_region_middle_east(inputs)
	if (locale === "zh") return zh_region_middle_east(inputs)
	return zh_hant_region_middle_east(inputs)
});